module.exports = __webpack_public_path__ + "static/media/Orcamentos3.aa643d31.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos3.png
// module id = 2098
// module chunks = 0